import { useEffect } from 'react';

import type { DescriptionPage_Partner as Partner } from '__generated__/graphql-types-do-not-use';

import user from 'js/lib/user';

import type { PartnerType } from 'bundles/enterprise-legacy-xdp/components/banner/Partner';
import GoogleCertificateEpicClient from 'bundles/epic/clients/GoogleCertificate';

// The Google Price test is limited to the Google Career Certificates partner for now.
const GOOGLE_PARTNERS_IN_PRICE_TEST = [463];

type Partners = Array<Partner | PartnerType> | null;

export const getIsPartnerEligibleForGooglePriceTest = (partners?: Partners) => {
  const isPartnerEligibleForGooglePriceTest = partners?.some((partner) =>
    GOOGLE_PARTNERS_IN_PRICE_TEST.includes(Number(partner?.id))
  );

  return Boolean(isPartnerEligibleForGooglePriceTest);
};

type GooglePriceImpressionInput = {
  hasSpecialization: boolean;
  partners?: Partners;
};

/**
 Generate price test for the following Google pricing experiments:
 * India: https://tools.coursera.org/epic/experiment/C0lmokW5Ee6YYwrfq_--AQ
 * Low-income countries excluding India: https://tools.coursera.org/epic/experiment/eVceI0W6Ee6YYwrfq_--AQ
 */
const useGenerateGooglePriceTestImpression = ({ hasSpecialization, partners }: GooglePriceImpressionInput) => {
  useEffect(() => {
    if (user.isAuthenticatedUser() && hasSpecialization && getIsPartnerEligibleForGooglePriceTest(partners)) {
      GoogleCertificateEpicClient.get('2023q3-google-geo-price-test-india-param');
      GoogleCertificateEpicClient.get('2023q3-google-geo-price-test-excl-india-param');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSpecialization, partners?.[0]?.id]);
};

export default useGenerateGooglePriceTestImpression;
